enum PaymentMethodTypeEnum {
    CREDIT_CARD = "CREDIT_CARD",
    PAYPAL = "PAYPAL",
    APPLE_PAY = "APPLE_PAY",
    // While there are others, the above are the only ones we use.
}

export default PaymentMethodTypeEnum;
